import React, {useState} from 'react'
import AppLayout from '@/Layouts/AppLayout'
import useLang from "@/Hooks/useLang";
import Text from "@/Components/Front/Text";
import DataScience from "@/Components/Front/SVGS/Services/DataScience";
import {Link} from "@inertiajs/inertia-react";
import ChevronRight from "@/Components/Front/SVGS/ChevronRight";
import Database from "@/Components/Front/SVGS/Services/Database";
import DatabaseSmall from "@/Components/Front/SVGS/Services/DatabaseSmall";
import Gad from '@/Components/Front/PNGS/gad.png';
import LineaMeta from "@/Components/Front/SVGS/LineaMeta";
import LineaOption from "@/Components/Front/SVGS/LineaOption";
import LineaData from "@/Components/Front/SVGS/LineaData";
import LineaDb from "@/Components/Front/SVGS/LineaDb";
import ChevronLeft from "@/Components/Front/SVGS/ChevronLeft";
import ArrowBack from "@/Components/Front/SVGS/ArrowBack";
import Header from "@/Components/Front/Header";
import {useMediaQuery} from "react-responsive";
import ChevronRightAlt from "@/Components/Front/SVGS/ChevronRightAlt";

export default function ServicesDataScience(props) {

    const [lang, setLang] = useLang(props.locale);


    const textProps = {
        lang: lang, language: props.language,
    };
    const isMobile = useMediaQuery({query: '(max-width: 639px)'});
    const isMobileAndTabletPortrait = useMediaQuery({query: '(max-width: 767px)'});
    const isSm = useMediaQuery({query: '(min-width: 640px)'})
    const isMd = useMediaQuery({query: '(min-width: 768px)'})
    const isLg = useMediaQuery({query: '(min-width: 1024px)'})
    const isXl = useMediaQuery({query: '(min-width: 1366px)'})
    const is2Xl = useMediaQuery({query: '(min-width: 1800px)'})
    const is3Xl = useMediaQuery({query: '(min-width: 2400px)'})

    return (
        <AppLayout {...props}>
            <Header textProps={textProps} locale={lang} language={props.language} setLang={setLang}
                    activeItem={"services-database"}/>


            <section id="database" className={"services-page"}>
                {isMobileAndTabletPortrait &&
                    <>
                        <div className={"back-arrow"}>
                            <Link href={"/"}>
                                <ChevronRightAlt/>
                            </Link>
                        </div>
                        <div className={"mobile-image"}>
                            <img src="images/DatabaseSmall.png" alt=""/>

                        </div>
                    </>
                }

                <div className="in-frame-inner">

                    {isMd &&
                        <>
                            {/*<div className={"section-gradient"}>*/}
                            {/*    <img src={Gad} alt=""/>*/}
                            {/*</div>*/}
                            <div className={"section-background"}>
                                <img src="images/DatabaseBig.png" alt=""/>
                                {/*<Database/>*/}
                            </div>
                        </>
                    }
                    <div className={"section-title"}>
                        <div className={"service-icon"}>
                            <LineaDb/>
                        </div>
                        <div className={"service-back-button"}>
                            <Link href={"/"}>
                                <ArrowBack/>
                            </Link>
                        </div>
                        <h1>
                            <span><Text {...textProps} str={"database-title-1"}/></span>
                            <span><Text {...textProps} str={"database-title-2"}/></span>
                        </h1>

                        <div className={"services-data-container"}>


                            <p>
                                <Text {...textProps} str={"database-text-1"} html={true}/>
                            </p>
                            <p>
                                <Text {...textProps} str={"database-text-2"} html={true}/>
                            </p>
                        </div>

                    </div>


                    <div className={"database-services"}>

                        <article className={"services-link"}>
                            <div className={"article-header"}>
                                <LineaOption/>

                                <h1><Text {...textProps} str={"database-systematic-review"}/></h1>

                            </div>
                            <div className={"article-content"}>

                                <p><Text {...textProps} str={"database-systematic-review-text"}/></p>
                            </div>
                            <Link href={"/services-systematic-reviews"}>
                                <div className={"article-footer"}>
                                    <div className={"button"}>

                                        <Text {...textProps} str={"ver-mas"}/>
                                    </div>

                                </div>
                            </Link>

                        </article>
                        <article className={"services-link"}>
                            <div className={"article-header"}>
                                <LineaMeta/>

                                <h1><Text {...textProps} str={"database-meta-analysis"}/></h1>

                            </div>
                            <div className={"article-content"}>

                                <p><Text {...textProps} str={"database-meta-analysis-text"}/></p>
                            </div>
                            <Link href={"/services-meta-analysis"}>
                                <div className={"article-footer"}>
                                    <div className={"button"}>

                                        <Text {...textProps} str={"ver-mas"}/>
                                    </div>

                                </div>
                            </Link>

                        </article>


                    </div>

                    <div className={"back-button"}>
                        <Link href={"/"}>
                            <div>
                                <ChevronRight/> <Text {...textProps} str={"back"}/>

                            </div>
                        </Link>
                    </div>
                </div>
            </section>
        </AppLayout>

    )
}
